// src/components/hooks/CountrySelector.js
import React from 'react';
import PropTypes from 'prop-types';
import Flags from "react-world-flags";

const countries = [
    { code: "CM", name: "Cameroun" },
    { code: "BF", name: "Burkina Faso" },
    { code: "CI", name: "Côte d'Ivoire" },
    { code: "BJ", name: "Bénin" },
    { code: "SN", name: "Sénégal" },
];

const CountrySelector = ({ value, onChange, isInvalid, isValid }) => {
    // Fonction pour gérer le changement de sélection
    const handleChange = (e) => {
        const selectedCountry = countries.find(country => country.code === e.target.value);
        onChange(selectedCountry ? selectedCountry.name : ''); // Retourne le nom du pays
    };

    // Trouver le code ISO correspondant au nom du pays sélectionné
    const selectedCountryCode = countries.find(country => country.name === value)?.code || '';

    return (
        <div className="country-selector">
            <select
                value={selectedCountryCode} // Utilise le code ISO comme valeur
                onChange={handleChange}
                className={`form-control ${isInvalid ? 'is-invalid' : ''} ${isValid ? 'is-valid' : ''}`}
            >
                <option value="">Sélectionnez un pays</option>
                {countries.map((country) => (
                    <option key={country.code} value={country.code}>
                        {country.name}
                    </option>
                ))}
            </select>
            {value && (
                <div className="flag-container">
                    <Flags code={selectedCountryCode} height="16" />
                </div>
            )}
        </div>
    );
};

CountrySelector.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    isInvalid: PropTypes.bool,
    isValid: PropTypes.bool
};

export default CountrySelector;